import { render } from "./booking-commission-add.vue?vue&type=template&id=7b0d76ae&ts=true"
import script from "./booking-commission-add.vue?vue&type=script&lang=ts"
export * from "./booking-commission-add.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__